import { useMemo } from 'react';
import useSWR from 'swr';
import { LEGACY_APPROVAL_SEARCH_URL } from '@/constant/approval';
import { getNestedDataFetcher } from '@/utils/apis';

type DeactivatedApprover = {
  passportId: string;
  type: number;
  order: number;
  status: string;
  userId: string;
  name: string;
  placeName: string;
  placeCode: string;
  departmentName: string;
  departmentCode: string;
  positionName: string;
  positionCode: string;
  opinion: string;
  approvedAt: string;
  createdAt: string;
  updatedAt: string;
};

/**
 * 특정 품의 문서의 결재라인에서 퇴사한 결재자 목록을 조회.
 * - documentId 없으면(신규 작성) 호출 skip — SWR key null.
 * - 반환되는 Set은 passportId 기반. 결재라인 렌더 시 FlowMemberData.userId와 비교.
 */
const useDeactivatedApprovers = (documentId?: string | null) => {
  const { data, error, isLoading } = useSWR<DeactivatedApprover[]>(
    documentId
      ? `${LEGACY_APPROVAL_SEARCH_URL}/${documentId}/approvers/deactivated`
      : null,
    getNestedDataFetcher,
  );

  const deactivatedIds = useMemo(
    () => new Set((data ?? []).map((a) => a.passportId)),
    [data],
  );

  return { deactivatedIds, isLoading, error };
};

export default useDeactivatedApprovers;
